exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./packages/layout/node_modules/core-js/library/modules/_object-pie.js
// module id = 213
// module chunks = 0